import { useState, type FormEvent } from 'react'
import { BrandLockup } from '../brand'
import { ApiError, requestOtp, verifyOtp } from '../api'
import { CABINET_URL } from '../env'
import { LanguageSwitch, t } from '../i18n'

export function Login({ onSuccess }: { onSuccess: (token: string) => void }) {
  const [email, setEmail] = useState('')
  const [code, setCode] = useState('')
  const [stage, setStage] = useState<'email' | 'code'>('email')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  function backToEmail() {
    setStage('email')
    setCode('')
    setError(null)
  }

  async function submit(e: FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      if (stage === 'email') {
        await requestOtp(email.trim())
        setStage('code')
      } else {
        const token = await verifyOtp(email.trim(), code.trim())
        onSuccess(token)
      }
    } catch (err) {
      const msg =
        err instanceof ApiError
          ? err.status === 401
            ? t('Невірний код.')
            : err.message
          : t('Не вдалося зʼєднатися з бекендом.')
      setError(msg)
    } finally {
      setBusy(false)
    }
  }

  return (
    <main className="pane">
      <header className="pane-head">
        <h1>
          <BrandLockup compact />
        </h1>
        <div className="head-actions">
          <LanguageSwitch />
          <a href={CABINET_URL} target="_blank" rel="noreferrer">{t('Кабінет')}</a>
        </div>
      </header>
      <form className="card" onSubmit={submit}>
        {stage === 'email' ? (
          <label>
            Email
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              placeholder="you@firm.com"
              required
            />
          </label>
        ) : (
          <label>{t('Код з листа')}<input
              type="text"
              inputMode="numeric"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              autoComplete="one-time-code"
              placeholder="000000"
              required
            />
          </label>
        )}
        <p className="muted">
          {stage === 'email'
            ? t('Надішлемо одноразовий код на цю пошту.')
            : t('Код надіслано на {email}. Немає листа — перевірте «Спам».', { email })}
        </p>
        {error ? <p className="error">{error}</p> : null}
        <button type="submit" disabled={busy}>
          {busy ? t('Чекайте…') : stage === 'email' ? t('Надіслати код') : t('Увійти')}
        </button>
        {stage === 'code' ? (
          <button type="button" className="secondary" onClick={backToEmail} disabled={busy}>{t('Змінити пошту')}</button>
        ) : null}
      </form>
    </main>
  )
}
